import { useMutation } from "@tanstack/react-query";
import { bookingsBulkMove, BookingsBulkMovePayload } from "PFCore/services/bookings_bulk_move";
import { MutationOptions } from "PFTypes";

import { useProfileInvalidate } from "../../profile";

type BulkMoveResponse = {
  bookingIds: number[];
};

export const useBookingsBulkMove = ({
  onSuccess,
  ...options
}: MutationOptions<BookingsBulkMovePayload> = {}) => {
  const { invalidateProfileWithBooking } = useProfileInvalidate();
  return useMutation(async (payload: BookingsBulkMovePayload) => bookingsBulkMove(payload), {
    onSuccess: (...args) => {
      const response = args[0] as BulkMoveResponse;
      response.bookingIds.forEach(invalidateProfileWithBooking);
      onSuccess?.(...args);
    },
    ...options
  });
};
